import React, { useState } from "react";

const UpdateContactModal = ({ user, onClose }) => {
    const [email, setEmail] = useState(user.email);
    const [phone, setPhone] = useState(user.phone || "");
    const [address, setAddress] = useState(user.address || "");

    const formatPhoneNumber = (value) => {
        const digits = value.replace(/\D/g, "").slice(0, 10); // Allow only digits, max 10
        const formatted = digits.replace(/(\d{3})(\d{3})(\d{1,4})/, (_, p1, p2, p3) => {
            return `${p1}-${p2}-${p3}`.trim();
        });
        return formatted;
    };

    const handlePhoneChange = (e) => {
        const formattedPhone = formatPhoneNumber(e.target.value);
        setPhone(formattedPhone);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the update logic here (e.g., dispatch an action to update the user info)
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="w-full max-w-md rounded-xl border border-stone-200 bg-white p-6 shadow-2xl">
                <h2 className="mb-4 text-xl font-semibold tracking-tight text-stone-900">Update Contact Information</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="mb-1 block text-sm font-medium text-stone-700">Email</label>
                        <input 
                            type="email" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            className="h-10 w-full rounded-md border border-stone-300 px-3 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-stone-400"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="mb-1 block text-sm font-medium text-stone-700">Phone</label>
                        <input 
                            type="text" 
                            value={phone} 
                            onChange={handlePhoneChange} 
                            className="h-10 w-full rounded-md border border-stone-300 px-3 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-stone-400"
                            placeholder="###-###-####"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="mb-1 block text-sm font-medium text-stone-700">Address</label>
                        <textarea 
                            value={address} 
                            onChange={(e) => setAddress(e.target.value)} 
                            className="w-full rounded-md border border-stone-300 px-3 py-2 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-stone-400"
                        />
                    </div>
                    <div className="flex justify-end space-x-2">
                        <button 
                            type="button" 
                            onClick={onClose} 
                            className="rounded-md border border-stone-300 bg-white px-4 py-2 text-sm font-medium text-stone-700 transition hover:bg-stone-100"
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="rounded-md bg-stone-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-stone-800"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateContactModal;
